/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1765
 */

"use strict"

var r = require(/* 257 */"../1754/257/index")
var o = require(/* 1251 */"./1251")
var /* [auto-meaningful-name] */r$aTypedArray = r.aTypedArray;
(0, r.exportTypedArrayMethod)("lastIndexOf", function (e) {
  return o.apply(r$aTypedArray(this), arguments)
})
